import {
	useDcrModalActions,
	useDcrModalState
} from '@/core/store/dcrModal/dcrModalSelectors';

import { DcrFormModal } from './DcrFormModal/DcrFormModal';

export const DcrFormRoot = () => {
	const { entityType, isOpen, mountKey } = useDcrModalState();
	const { close, exited, setLoaded } = useDcrModalActions();

	if (!entityType) return null;

	return (
		<DcrFormModal
			key={mountKey}
			open={isOpen}
			entityType={entityType}
			onClose={close}
			onExited={exited}
			onLoaded={setLoaded}
		/>
	);
};
